export const SessionTabs = ({ sessions, selected, onSelect }) => {
  if (!sessions || sessions.length === 0) return null;
  return (
    <div className="flex items-center gap-1 flex-wrap" role="tablist">
      {sessions.map((s) => {
        const active = s.code === selected;
        return (
          <button
            key={s.code}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(s.code)}
            className={`px-3 py-1 text-xs font-medium rounded-md border transition-colors ${
              active
                ? 'bg-f1-red/15 border-f1-red/60 text-f1-text'
                : 'bg-f1-surface border-f1-border text-f1-muted hover:text-f1-text hover:border-f1-muted'
            }`}
            title={s.label}
          >
            {s.code}
          </button>
        );
      })}
    </div>
  );
};
